import { ListItemIcon as MuiListItemIcon } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import { ListItemButton } from '@mui/material';

export const ListItemIcon = styled(MuiListItemIcon)(() => ({
  minWidth: '48px',
  height: '48px',
  color: 'inherit',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '8px',
  transition: 'all 0.2s ease-in-out',
  '& svg': {
    fontSize: '24px',
  },
}));

export const ListItemButtonText = styled('div')(({ isSelected }: { isSelected?: boolean }) => {
  const theme = useTheme();

  return {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: `0 ${theme.spacing(1.25)}`,
    color: isSelected ? theme.palette.primary.main : 'inherit',
  };
});

export const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({
  borderRadius: '12px',
  margin: theme.spacing(0, 0.5, 0, 1),
  padding: theme.spacing(0, 0),

  '&.Mui-selected': {
    '& .MuiListItemIcon-root': {
      backgroundColor: 'transparent',

      '&:hover': {
        backgroundColor: theme.palette.primary.states.selected,
        boxShadow: 'none',
      },
    },
  },
}));
